/**
 * FileUploadInstructions Component
 *
 * This component provides guidelines and visual examples for uploading files
 * with professional-looking results. It displays recommended formats, aspect
 * ratios, dimensions, and supported file types for the uploaded files.
 *
 * @component
 *
 * @example
 * // Usage
 * <FileUploadInstructions />
 *
 * @returns {JSX.Element} A React component that renders a container with file upload instructions,
 *                        including a list of guidelines and a visual representation of the recommended aspect ratio.
 */
import React from 'react';
import './FileUploadInstructions.scss';

// TODO: Enhance this component to support dynamic customization of file upload guidelines.
const FileUploadInstructions = () => {
    return (
        <div className="upload-info-container">
            <div className="upload-instructions">
                <p>For professional-looking results:</p>
                <ul className="requirements-list">
                    <li><strong>Recommended format:</strong> Landscape orientation</li>
                    <li><strong>Ideal aspect ratio:</strong> 1.75:1 (width:height)</li>
                    <li><strong>Suggested dimensions:</strong> 700×400px or 875×500px</li>
                    <li><strong>Supported file types:</strong> PNG, JPG (including .jpeg), case-insensitive</li>
                </ul>
            </div>
            <div className="ratio-example">
                <div className="ratio-box">
                    <div className="ratio-inner">
                        1.75:1 ratio
                    </div>
                    <div className="ratio-label">Recommended</div>
                </div>
            </div>
        </div>
    );
};

export default FileUploadInstructions;